import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBedcEduDmHRV5769TMYiPWEvoYQ9KHa-U",
  authDomain: "inmobiliaria-confalonieri.firebaseapp.com",
  projectId: "inmobiliaria-confalonieri",
  storageBucket: "inmobiliaria-confalonieri.firebasestorage.app",
  messagingSenderId: "890944082001",
  appId: "1:890944082001:web:e344a5c19a71059a972870",
  measurementId: "G-CB7CT3P083"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);